import React, { forwardRef } from 'react';
import ViewInvoice from './ViewInvoice';

const PrintableInvoicePreview = forwardRef((props, ref) => {
  const { invoiceIDArray, invoiceArrayIndex, invoiceGroupsData, viewAll } = props;
  if (viewAll) {
    return (
      <div ref={ref} className="px-3 position-relative">
        {invoiceIDArray.map((id, index) => (
          <div key={id} className="printable-item">
            <ViewInvoice
              invoiceID={invoiceIDArray[index]}
              invoiceData={invoiceGroupsData[index]}
            />
            {index < (invoiceIDArray.length) && (
              <div className="page-break" />
            )}
          </div>
        ))}
      </div>
    );
  }
  //  this is the ELSE case - NOT viewAll
  return (
    <div ref={ref} className="p-5">
      <ViewInvoice
        invoiceID={invoiceIDArray[invoiceArrayIndex]}
        invoiceData={invoiceGroupsData[invoiceArrayIndex]}
      />
    </div>
  );
});

export default PrintableInvoicePreview;
